export const SEND_EDOK_FORM_SUCCESS = 'SEND_EDOK_FORM_SUCCESS';

export const sendEdokFormSuccess = ({ form }) => ({
    type: SEND_EDOK_FORM_SUCCESS,
    payload: {
        form,
    },
});
